export const WIZARD_STEPS = [
  { id: 'input', labelKey: 'drbfm.steps.input' },
  { id: 'processing', labelKey: 'drbfm.steps.processing' },
  { id: 'results', labelKey: 'drbfm.steps.results' },
] as const;

export const getStepIndex = (step: string): number => {
  const index = WIZARD_STEPS.findIndex((entry) => entry.id === step);
  return index === -1 ? 0 : index;
};
